import { render, staticRenderFns } from "./ThreadHello.vue?vue&type=template&id=7f6a90da&scoped=true"
import script from "./ThreadHello.vue?vue&type=script&lang=js"
export * from "./ThreadHello.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6a90da",
  null
  
)

export default component.exports